export default "__VITE_ASSET__DSTajEOA__"